import Box from '@material-ui/core/Box';
import Divider from '@material-ui/core/Divider';
import Grid from '@material-ui/core/Grid';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import { Star, StarOutlineOutlined } from '@material-ui/icons/';
import React, { useState } from 'react';
import AffirmationAddComponent from './Affirmation_Add';
import AllAffirmationsComponent from './Affirmation';
import CategoriesScreen from './Categories';
import AddCategoryComponent from './Category_Add';
import { Container } from '@material-ui/core';


function TellMeHome() {
    const [bodyItemText, setBodyItem] = useState('Affirmations');

    // Returns Body Element According to BodyItemText
    const BodyElement = () => {

        switch (bodyItemText) {
            case 'Affirmations':
                return <AllAffirmationsComponent />

            case 'Add Affirmation':
                return <AffirmationAddComponent />

            case 'Categories':
                return <CategoriesScreen />

            case 'Add Category':
                return <AddCategoryComponent />

            default:
                return <h1>Empty - Error!</h1>
        }
    }

    // Changes Body Element
    const DrawerComponent = () => (
        <Box width={240}>
            <List>
                {['Affirmations', 'Add Affirmation'].map((text, index) => (
                    <ListItem id={text} button key={text} onClick={() => setBodyItem(text)}>
                        <ListItemIcon>{index % 2 === 0 ? <Star /> : <StarOutlineOutlined />}</ListItemIcon>
                        <ListItemText primary={text} />
                    </ListItem>
                ))}
            </List>
            <Divider />
            <List>
                {['Categories', 'Add Category'].map((text, index) => (
                    <ListItem id={text} button key={text} onClick={() => setBodyItem(text)}>
                        <ListItemIcon>{index % 2 === 0 ? <Star /> : <StarOutlineOutlined />}</ListItemIcon>
                        <ListItemText primary={text} />
                    </ListItem>
                ))}
            </List>
        </Box>
    );


    return (
        <div>
            <Box height={80} />

            <Grid container>

                <DrawerComponent />

                <Container maxWidth="xl" style={{ height: 500 }}>
                    <BodyElement />
                </Container>

            </Grid>

            <Box height={80} />

        </div>
    );
}

export default TellMeHome;